import { DeactivateAccount } from 'actions/MyAccountActions/MyProfileInfoActions/deactivateAccountActions';
import { INIT } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';

const defaultState = {
	asyncStatus: INIT
};

export default createReducer(
	DeactivateAccount.REQUEST,
	DeactivateAccount.SUCCESS,
	DeactivateAccount.ERROR,
	defaultState
);
